import { BusinessCenter } from '@mui/icons-material'
import PmiEdit from './PmiEdit'
import PmiList from './PmiList'

const businessIndex = {
  icon: BusinessCenter,
  // creation of pmi user is NOT allowed (can be done just SF-side)
  edit: PmiEdit,
  list: PmiList,
}

export default businessIndex
